/* Sui Story — Barba.js page transitions.
   Disabled inside the Shopify Theme Editor (Shopify.designMode) and for
   reduced-motion users, so the editor and accessibility stay intact.
   Header/footer live outside [data-barba="wrapper"] and persist across swaps. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});

  S.initPageTransitions = function () {
    if (typeof barba === 'undefined' || typeof gsap === 'undefined') return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (S.reduceMotion()) return;

    barba.init({
      timeout: 7000,
      prevent: function (data) {
        var el = data.el;
        if (!el) return false;
        if (el.hasAttribute('data-barba-prevent')) return true;
        if (el.hasAttribute('target')) return true;
        var h = el.getAttribute('href') || '';
        if (!h) return true;
        if (/^(mailto:|tel:|#)/i.test(h)) return true;
        // Let Shopify handle commerce/account/admin natively
        if (/^\/(cart|checkout|account|admin|apps|\d)/.test(h) || h.indexOf('/checkouts/') !== -1) return true;
        // External links
        if (/^https?:\/\//i.test(h) && h.indexOf(window.location.host) === -1) return true;
        return false;
      },
      transitions: [{
        name: 'thread',
        leave: function (data) {
          if (S.stopLenis) S.stopLenis();
          // Opacity-only (no transform) so the outgoing layout can't skew measurements.
          return gsap.to(data.current.container, { opacity: 0, duration: 0.35, ease: 'power2.in' });
        },
        enter: function (data) {
          window.scrollTo(0, 0);
          // Return the tween so Barba waits for it; clearProps leaves no inline styles behind.
          return gsap.from(data.next.container, { opacity: 0, duration: 0.5, ease: 'power2.out', clearProps: 'opacity' });
        }
      }]
    });

    // Keep <body class="template-*"> in sync with the page being entered. The
    // body is NOT re-rendered on a Barba swap, so without this the homepage's
    // template-index class (and its transparent header) would bleed onto every
    // page navigated to client-side. Runs before the new container is shown.
    barba.hooks.beforeEnter(function (data) {
      var ns = data && data.next && data.next.namespace;
      if (!ns) return;
      var b = document.body;
      b.className = b.className
        .split(/\s+/)
        .filter(function (c) { return c && c.indexOf('template-') !== 0; })
        .join(' ');
      b.classList.add('template-' + ns);
    });

    // Re-init AFTER the swap fully completes. By the 'after' hook the outgoing
    // container has been removed from the DOM, so ScrollTrigger measures the REAL
    // layout — not the stale, doubled-up layout that left every reveal stuck at
    // opacity:0. Two rAFs let the browser apply layout before we rebuild + refresh.
    barba.hooks.after(function (data) {
      if (S.startLenis) S.startLenis();
      if (S.scrollToTop) S.scrollToTop();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (S.initPage) S.initPage(data.next.container);
          if (window.ScrollTrigger) ScrollTrigger.refresh(true);
        });
      });
      try {
        if (window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.track) {
          ShopifyAnalytics.lib.track('Viewed Page');
        }
      } catch (e) {}
    });
  };
})();
